import { render, staticRenderFns } from "./SwappTasksTextInfoDialog.vue?vue&type=template&id=16866284&scoped=true"
import script from "./SwappTasksTextInfoDialog.vue?vue&type=script&lang=js"
export * from "./SwappTasksTextInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16866284",
  null
  
)

export default component.exports